var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6269 0.609375H1.37226C0.798043 0.609375 0.439449 1.23516 0.72773 1.73438L6.17929 11.0016V16.6406C6.17929 17.0555 6.5121 17.3906 6.92461 17.3906H13.0746C13.4871 17.3906 13.8199 17.0555 13.8199 16.6406V11.0016L19.2738 1.73438C19.5598 1.23516 19.2012 0.609375 18.6269 0.609375ZM12.1418 15.7031H7.85742V12.0469H12.1441V15.7031H12.1418ZM12.3668 10.1578L12.1441 10.5469H7.85507L7.63242 10.1578L2.98476 2.29688H17.0144L12.3668 10.1578Z",
    fill: "#94DB4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.7fb6509964a7e2305e46adeca2122b1a.svg";
export { ForwardRef as ReactComponent };